import { frontPageSchema } from '~/utils/crystallize/front-page'

export function useFrontPageCmsData() {
  const options = useCatalogueQueryOptions({ path: '/forside', schema: frontPageSchema })

  return useQuery({
    ...options,
    staleTime: 1000 * 60 * 60, // 1 hour
  })
}
